import { useEffect } from "react";
import api from "@/lib/api";

// Injects Google AdSense loader script once, using the admin-configured client id.
// AdSense units can then be added inline via the analytics_code field or directly in components.
export default function AdSenseLoader() {
  useEffect(() => {
    let mounted = true;
    api.get("/site-info").then((r) => {
      if (!mounted) return;
      const client = (r.data?.adsense_client_id || "").trim();
      if (!client) return;
      if (document.querySelector(`script[data-ad-client="${client}"]`)) return;
      const s = document.createElement("script");
      s.async = true;
      s.crossOrigin = "anonymous";
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
      s.setAttribute("data-ad-client", client);
      document.head.appendChild(s);
    }).catch((err) => console.error("AdSense loader failed:", err));
    return () => { mounted = false; };
  }, []);
  return null;
}
